module.exports = __webpack_public_path__ + "assets/img/11_741_big.9513d519.jpg";